import React, { useEffect } from 'react';
import './AllModal.css';

function BookingDetailsModal({ booking, onClose }) {
  // Handle ESC key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]);

  // Handle click outside modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="booking-details-modal-overlay" onClick={handleOverlayClick}>
      <div className="booking-details-modal-content">
        <h2>Booking Details</h2>
        <div className="booking-details-grid">
          <div className="booking-details-item">
            <span className="label">Type:</span> {booking.type}
          </div>
          <div className="booking-details-item">
            <span className="label">Name on Reservation:</span> {booking.nameOnReservation}
          </div>
          <div className="booking-details-item">
            <span className="label">Reservation Number:</span> {booking.reservationNumber || 'N/A'}
          </div>
          <div className="booking-details-item">
            <span className="label">Dates:</span> 
            {new Date(booking.startDate).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true })} - 
            {new Date(booking.endDate).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true })}
          </div>
          <div className="booking-details-item">
            <span className="label">Details:</span>
            <pre>{JSON.stringify(booking.details, null, 2)}</pre>
          </div>
        </div>
        <div className="booking-details-modal-actions">
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default BookingDetailsModal;